import {
  Armchair,
  BadgeCheck,
  Banknote,
  Briefcase,
  Car,
  Crown,
  Globe,
  GraduationCap,
  Handshake,
  Landmark,
  Medal,
  Mic,
  Plane,
  Shield,
  Smartphone,
  Sparkles,
  Star,
  Users,
} from 'lucide-react';
import type { Tier } from '../types/tier';

export const tiers: Tier[] = [
  {
    id: 'associate',
    level: 1,
    name: 'Associate',
    nameAr: 'خبير مشارك',
    tagline: 'Verified member of the national expert network.',
    minScore: 0,
    criteria: ['Profile verified by BAK', 'At least 1 completed engagement', 'Signed BAK code of conduct'],
    icon: Shield,
    privileges: [
      { title: 'Listed in the national directory', description: 'Discoverable by all BAK organizers and partner entities.', category: 'Recognition', icon: BadgeCheck },
      { title: 'Local workshops & panels', description: 'Eligible for invitations to UAE-based workshops and panels.', category: 'Events', icon: Mic },
      { title: 'BAK expert app', description: 'Receive invitations, accept engagements and track payments.', category: 'Network', icon: Smartphone },
      { title: 'Standard payment terms', description: 'Invoices settled within 30 days.', category: 'Finance', icon: Banknote },
    ],
  },
  {
    id: 'fellow',
    level: 2,
    name: 'Fellow',
    nameAr: 'زميل',
    tagline: 'Proven contributor with consistent, well-rated engagements.',
    minScore: 67,
    criteria: ['Tier score of 67+', '3+ completed engagements', 'Average feedback of 4.0+'],
    icon: Medal,
    privileges: [
      { title: 'Priority invitations', description: 'First to be notified for events in your verified fields.', category: 'Events', icon: Sparkles },
      { title: 'Featured profile', description: 'Highlighted in organizer search results and recommendations.', category: 'Recognition', icon: Star },
      { title: 'BAK Majlis networking', description: 'Quarterly networking evenings with fellow experts and officials.', category: 'Network', icon: Users },
      { title: 'Professional development', description: 'Sponsored seats at executive training programmes.', category: 'Network', icon: GraduationCap },
      { title: 'Faster payment', description: 'Invoices settled within 15 days.', category: 'Finance', icon: Banknote },
    ],
  },
  {
    id: 'distinguished',
    level: 3,
    name: 'Distinguished',
    nameAr: 'خبير متميز',
    tagline: 'Trusted national voice for high-profile engagements.',
    minScore: 70,
    criteria: ['Tier score of 70+', 'Average feedback of 4.5+', 'Social engagement score of 75+'],
    icon: Crown,
    privileges: [
      { title: 'VIP treatment at national events', description: 'Reserved front-row seating, VIP lounge access and dedicated host.', category: 'Events', icon: Armchair },
      { title: 'Chauffeur & hospitality', description: 'Ground transport and hospitality covered for all BAK engagements.', category: 'Events', icon: Car },
      { title: 'Keynote priority', description: 'First consideration for keynote and moderator roles.', category: 'Recognition', icon: Mic },
      { title: 'GCC regional opportunities', description: 'Nominated for regional summits and joint GCC programmes.', category: 'Travel', icon: Plane },
      { title: '+10% rate uplift', description: 'Approved premium on standard day rate.', category: 'Finance', icon: Banknote },
    ],
  },
  {
    id: 'ambassador',
    level: 4,
    name: 'Ambassador',
    nameAr: 'سفير الخبرة',
    tagline: 'Represents the UAE’s expertise on the world stage.',
    minScore: 75,
    criteria: ['Tier score of 75+', '5+ years in the network', 'Endorsed by BAK leadership'],
    icon: Globe,
    privileges: [
      { title: 'Travel with official delegations', description: 'Join UAE government delegations on official state and ministerial visits.', category: 'Travel', icon: Landmark },
      { title: 'International representation', description: 'Represent the UAE at forums such as WEF, UN and World Government Summit sessions abroad.', category: 'Travel', icon: Globe },
      { title: 'Advisory board access', description: 'First access to federal and strategic advisory board seats.', category: 'Recognition', icon: Briefcase },
      { title: 'Ambassador’s Majlis', description: 'Annual private majlis with national leadership.', category: 'Network', icon: Handshake },
      { title: 'Dedicated relationship manager', description: 'A named BAK contact for scheduling, travel and logistics.', category: 'Network', icon: Users },
      { title: '+20% rate uplift & 7-day payment', description: 'Premium rate and priority settlement on every invoice.', category: 'Finance', icon: Banknote },
    ],
  },
];
